module.exports = __webpack_public_path__ + "static/flags/GY-112c1c2ae29d4c7039927ba3b238da77.gif";